import { Skeleton } from '@material-ui/lab';
import React from 'react';

export default <Skeleton variant="rect" height="100%" width="100%" />;
